/**
 * header.js - Header section interactions
 * Handles: Top Bar, Mega Menu, Mobile Drawer
 */
(function() {
  'use strict';

  function initHeader() {
    initTopBar();
    initMegaMenu();
    initMobileDrawer();
  }

  // ===== Top Bar Close =====
  function initTopBar() {
    var closeBtn = document.querySelector('[data-close-topbar]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        var topbar = closeBtn.closest('[data-topbar]');
        if (topbar) {
          topbar.classList.add('hidden');
        }
      });
    }
  }

  // ===== PC Mega Menu Hover Toggle =====
  function initMegaMenu() {
    var navItems = document.querySelectorAll('[data-menu]');
    var megaMenus = document.querySelectorAll('[data-mega-menu]');
    var hideTimeout = null;
    var currentMenu = null;

    function showMegaMenu(menuId) {
      clearTimeout(hideTimeout);
      var target = document.querySelector('[data-mega-menu="' + menuId + '"]');

      // Same menu, no action needed
      if (currentMenu === target) return;

      // Close current menu instantly (skip CSS transition to avoid flicker)
      if (currentMenu) {
        currentMenu.style.transition = 'none';
        currentMenu.classList.add('max-h-0', 'opacity-0');
        currentMenu.classList.remove('max-h-[600px]', 'opacity-100');
        requestAnimationFrame(function() {
          currentMenu.style.transition = '';
        });
      }

      // Clean up any stray menus that aren't current or target
      megaMenus.forEach(function(menu) {
        if (menu !== target && menu !== currentMenu) {
          menu.classList.add('max-h-0', 'opacity-0');
          menu.classList.remove('max-h-[600px]', 'opacity-100');
        }
      });

      // Show target menu with normal transition
      if (target) {
        target.classList.remove('max-h-0', 'opacity-0');
        target.classList.add('max-h-[600px]', 'opacity-100');
      }

      currentMenu = target;
    }

    function hideMegaMenu() {
      hideTimeout = setTimeout(function() {
        if (currentMenu) {
          currentMenu.classList.add('max-h-0', 'opacity-0');
          currentMenu.classList.remove('max-h-[600px]', 'opacity-100');
          currentMenu = null;
        }
      }, 200);
    }

    // Attach hover events to nav items with mega menus
    navItems.forEach(function(item) {
      var menuId = item.getAttribute('data-menu');
      item.addEventListener('mouseenter', function() {
        showMegaMenu(menuId);
      });
      item.addEventListener('mouseleave', function() {
        hideMegaMenu();
      });
    });

    // Keep mega menu open when mouse enters the menu itself
    megaMenus.forEach(function(menu) {
      menu.addEventListener('mouseenter', function() {
        clearTimeout(hideTimeout);
      });
      menu.addEventListener('mouseleave', function() {
        hideMegaMenu();
      });
    });
  }

  // ===== Mobile Drawer Toggle =====
  function initMobileDrawer() {
    var openBtn = document.querySelector('[data-open-drawer]');
    var closeBtn = document.querySelector('[data-close-drawer]');
    var drawer = document.querySelector('[data-drawer]');
    var overlay = document.querySelector('[data-drawer-overlay]');

    function openDrawer() {
      if (drawer) {
        drawer.classList.remove('-translate-x-full');
        drawer.classList.add('translate-x-0');
      }
      if (overlay) {
        overlay.classList.remove('opacity-0', 'invisible');
        overlay.classList.add('opacity-100', 'visible');
      }
      document.body.classList.add('overflow-hidden');
    }

    function closeDrawer() {
      if (drawer) {
        drawer.classList.remove('translate-x-0');
        drawer.classList.add('-translate-x-full');
      }
      if (overlay) {
        overlay.classList.remove('opacity-100', 'visible');
        overlay.classList.add('opacity-0', 'invisible');
      }
      document.body.classList.remove('overflow-hidden');
    }

    if (openBtn) {
      openBtn.addEventListener('click', openDrawer);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closeDrawer);
    }

    if (overlay) {
      overlay.addEventListener('click', closeDrawer);
    }

    // Prevent drawer close when clicking inside drawer
    if (drawer) {
      drawer.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    }

    // ===== Mobile Submenu Toggle =====
    var mobileToggles = document.querySelectorAll('[data-mobile-toggle]');
    
    mobileToggles.forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        var menuId = toggle.getAttribute('data-mobile-toggle');
        var submenu = document.querySelector('[data-mobile-submenu="' + menuId + '"]');
        var icon = toggle.querySelector('.submenu-icon');
        
        if (submenu) {
          var isOpen = submenu.classList.contains('max-h-[500px]');
          
          // Close all other submenus first
          var allSubmenus = document.querySelectorAll('[data-mobile-submenu]');
          allSubmenus.forEach(function(sm) {
            sm.classList.remove('max-h-[500px]');
            sm.classList.add('max-h-0');
          });
          
          var allIcons = document.querySelectorAll('.submenu-icon');
          allIcons.forEach(function(ic) {
            var vertLine = ic.querySelector('.icon-vertical');
            if (vertLine) vertLine.classList.remove('opacity-0');
          });
          
          // Toggle current submenu
          if (!isOpen) {
            submenu.classList.remove('max-h-0');
            submenu.classList.add('max-h-[500px]');
            if (icon) {
              var vertLine = icon.querySelector('.icon-vertical');
              if (vertLine) vertLine.classList.add('opacity-0');
            }
          }
        }
      });
    });
  }

  // ===== Localization Toggle (Optional) =====
  function initLocalization() {
    var localeToggle = document.querySelector('[data-locale-toggle]');
    if (localeToggle) {
      localeToggle.addEventListener('click', function() {
        // Find and submit the localization form
        var form = localeToggle.closest('form') || document.querySelector('.localization-form');
        if (form) {
          form.classList.toggle('hidden');
        }
      });
    }
  }

  // ===== Auto-initialize =====
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeader);
  } else {
    initHeader();
  }

})();
